import { ConfirmationResult, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../configs/firebase";
import { useApi } from "./api";
import {
  AccountType,
  LoginDTO,
  RegisterDTO,
  UploadDocumentDTO,
  VerifyAccountDTO,
} from "../models";
import { useContextState } from '../context/Context';
import { useNavigate } from "react-router-dom";

let confirmationResult: ConfirmationResult;

export const useAuth = () => {
  const navigate = useNavigate();
  const { accountCTX } = useContextState();
  const { signedIn, setSignedIn, profile, setProfile, setRequiredDocuments, phoneValidation, setPhoneValidation } = accountCTX
  
  const { $post, $get, setTokens } = useApi();

  const verifyAccount = async (credentials: VerifyAccountDTO) => {
    // console.log('credentials', credentials)
    const data = await $post( "backend/account/action/check_if_account_exists/", {...credentials, account_type: 'direction'}, false );
    // console.log(data)
    return data;
  };

  const verifyPhoneNumber = async (credentials: {phoneNumber: string}) => {
    const data = await $post("account/action/generate_otp/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.res.toLowerCase() === 'success'){setPhoneValidation({...data.data, 'status':'pending'})}
    return data;
  };

  const verifyOtp = async (credentials: {phoneNumber: string, code_id: string}) => {
    const data = await $post("account/action/validate_otp/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res == 'success'){setPhoneValidation({...phoneValidation, 'status':'active'})}
    return data;
  };

  const resetToken = async () => {};

  const login = async (credentials: LoginDTO) => {
    // console.log(credentials)
    const data = await $post("backend/account/signin/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() === "success") {
      if (data.status === 'active'){
        const { pic, title, username, country, name, qr_image, cash, number, card_status, card_qr, notifications_count, bonus, required_document, required_documents_status, res, } = data;
        setSignedIn(true);
        setRequiredDocuments(data.required_document)
        setProfile({
          username,
          country,
          name,
          avatar: pic
            ? pic.includes("//")
              ? pic
              : "http://127.0.0.1:8000" + pic
            : null,
          qr_image,
          cash,
          number,
          card_status,
          card_qr,
          notifications_count,
          bonus,
          required_document,
          required_documents_status,
          title
        });
      }
      else if (data.res == "pending documents"){
        setRequiredDocuments(data.data)
        navigate("/documents")
        // return data
      }
    }
    return {
      isAuth: data.res.toLowerCase() === "success",
      message: data.message,
      remaining_trials: data.remaining_trials,
    };
  };

  const logout = async (account_type: AccountType) => {
    const data = await $post("backend/account/signout/", { account_type }, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() !== "success") return;
    setSignedIn(false)
    window.localStorage.clear();
    window.sessionStorage.clear();
    return true;
  };

  const register = async (credentials: RegisterDTO) => {
    const data = await $post("backend/account/signup/", credentials, false);
    // console.log(data);
    if (!data) return;
    if (data.res.toLowerCase() !== "success") return;
    return data
  };

  const uploadSignupDocument = async (credentials: UploadDocumentDTO) => {
    const data = await $post("account/document/action/upload_document/", credentials, false);
    return data;
  };

  const uploadDocument = async (credentials: UploadDocumentDTO) => {
    const data = await $post("backend/account/document/action/upload_document/", credentials, false);
    return data;
  };

  const updatePassword = async (credentials: LoginDTO) => {
    const data = await $post("backend/account/update_password/", credentials, false);
    if (!data) return;
    // console.log(data);
    return data
  };

  return {
    verifyPhoneNumber,
    verifyAccount,
    resetToken,
    verifyOtp,
    login,
    register,
    updatePassword,
    uploadSignupDocument,
    uploadDocument,
    logout,
  };
};
